export default {
  SET_TICKET_LIST(state, ticketList) {
    state.ticketList = ticketList;
    sessionStorage.setItem('PAYMENT_TICKET_LIST', JSON.stringify(ticketList));
  },
  SET_CHARGE_TICKET_LIST(state, chargeTicketList) {
    state.chargeTicketList = chargeTicketList;
    sessionStorage.setItem('CHARGE_TICKET_LIST', JSON.stringify(chargeTicketList));
  },
  RESET_CHARGE_TICKET_LIST(state) {
    state.chargeTicketList = [];
    sessionStorage.removeItem('CHARGE_TICKET_LIST');
    localStorage.removeItem('CHARGE_TICKET_LIST');
  },
};
